// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-AOx","toggleWrap":"styles_toggleWrap__3YhES","content":"styles_content__1n_Vv","selectAreaCode":"styles_selectAreaCode__1WQvt"};